import { useEffect, useState } from 'react';

// True once this component has mounted in the browser. Before that — the server-rendered output,
// or a slow connection where the JavaScript hasn't arrived yet — it's false, so a control that
// can't do anything yet (no click handler is attached) can say so with aria-disabled instead of
// silently ignoring a tap (LANE-D-33). It never disables the control for real: after hydration
// this flips back to false and the control works exactly as before.
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
